import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ProductSidebarDeliveryAccordion from '../ProductSidebarDeliveryAccordion/ProductSidebarDeliveryAccordion';
import readConfig from '../../../utils/readClientConfiguration';
import appConfiguration from '../../../config/default.json';
import './ProductSidebarDelivery.scss';
import { isHR, isSI } from '../../../utils/isHr';

// Funkcja obliczająca datę dostawy z uwzględnieniem świąt
// function calculateDaysIncludingHolidays(calculateTodayDate, daysToDelivery) {
//     let day = moment().add(1, 'day');
//     let holidays = 0;
//     for (let i = 0; i < daysToDelivery; i++) {
//         if (hd.isHoliday(day) !== false) {
//             holidays += 1;
//         }
//         day = business.addWeekDays(day, 1);
//     }
//     let dayIncludingHolidays = business.addWeekDays(calculateTodayDate(), holidays + daysToDelivery);
//     while (hd.isHoliday(dayIncludingHolidays) !== false) {
//         dayIncludingHolidays = business.addWeekDays(dayIncludingHolidays, 1);
//     }
//     return dayIncludingHolidays;
// }

const ProductSidebarDelivery = ({ product }) => {
    const { t } = useTranslation();
    const countryCode = readConfig(appConfiguration, 'countryCode') || 'HR'; // Domyślnie HR
    const { __typename, days_to_delivery_range, canonical_url, sku, name, is_saleable } = product;

    if (!days_to_delivery_range) {
        return null;
    }

    const date_from = new Date(days_to_delivery_range.from * 1000);
    const date_to = new Date(days_to_delivery_range.to * 1000);
    const options = { day: '2-digit', month: '2-digit' };

    const pickupEnabled = !isSI; // Simplified logic
    const showPickup = pickupEnabled && is_saleable; // Pickup only if saleable

    return (
        <div className="sidebar-delivery">
            {is_saleable && (
                <div className="delivery-options colored">
                    <img src="https://s3.emmezeta.hr/falcon/delivery.svg" className="delivery-options__icon" />
                    <div>
                        {t('product.standardDeliveryTime')}{' '}
                        <span style={{ fontWeight: 'bold' }}>
                          {t('product.standardDeliveryTime2', {
                              fromDays: date_from.toLocaleDateString(countryCode, options),
                              toDays: date_to.toLocaleDateString(countryCode, options),
                          })}
                        </span>
                        {isHR && t('product.standardDeliveryTime3')}
                    </div>
                </div>
            )}
            {showPickup && <ProductSidebarDeliveryAccordion product={product} />}
        </div>
    );
};

ProductSidebarDelivery.propTypes = {
    product: PropTypes.shape({
        __typename: PropTypes.string,
        days_to_delivery_range: PropTypes.shape({
            from: PropTypes.number,
            to: PropTypes.number,
        }),
        canonical_url: PropTypes.string,
        sku: PropTypes.string,
        name: PropTypes.string,
        is_saleable: PropTypes.bool,
    }).isRequired,
};

export default ProductSidebarDelivery;